import { useState } from 'react';
import {
  canViewPredictionsEarly,
  PAYMENT_TIER_GOLD,
} from '@mondy/shared';
import { useCurrentUser } from '@/hooks/useCurrentUser';
import { UpgradeModal, type UpgradeReason } from '@/components/UpgradeModal';

// Contextual upsell rendered inside MatchPredictions' locked-state body for
// users below Gold. Gold+ never see it because the server already returned
// the predictions list (revealed: true). Owns the lock message itself so the
// caller's locked-state body is a single component.
export function ViewPredictionsEarlyUpgradeCTA() {
  const user = useCurrentUser();
  const [open, setOpen] = useState(false);

  if (!user || canViewPredictionsEarly(user.paymentTier)) return null;

  const reason: UpgradeReason = {
    code: 'VIEW_PREDICTIONS_EARLY',
    requiredTier: PAYMENT_TIER_GOLD,
    currentTier: user.paymentTier,
  };

  return (
    <>
      <div className="mt-3 flex flex-col items-center gap-2 text-center">
        <p className="text-sm text-[color:var(--color-fg-muted)]">
          🔒 Predictions revealed at kickoff
        </p>
        <p className="text-sm font-semibold text-[color:var(--color-fg)]">
          See predictions before kickoff with Gold
        </p>
        <p className="text-xs text-[color:var(--color-fg-muted)]">
          Gold unlocks your group's predictions instantly — no need to wait for kickoff.
        </p>
        <button
          type="button"
          onClick={() => setOpen(true)}
          className="btn btn-primary mt-1"
        >
          Upgrade
        </button>
      </div>
      <UpgradeModal
        open={open}
        onClose={() => setOpen(false)}
        reason={reason}
      />
    </>
  );
}
